import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_task.scss';
import getResponse from '../actions/Brands.js';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';

import downArrow from '../../images/common/bluedownarrow.png';
import upArrow from '../../images/common/blueuparrow.png';
import closeIcon from '../../images/popups/upload/closeicon.png';

function ClickOutside(ref, setDropdownClick) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setDropdownClick(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}

function AddTaskTemplate(props) {
    const navigate = useNavigate();
    const {setTaskTemplateDetails, taskTemplateDetails, taskTemplateShow, handleTaskTemplateClose, getTaskTemplateDetails} = props
    const [isDropdownClicked, setDropdownClick] = useState(false);
    const [templateList, setTemplateList] = useState([]);

    const dropdownwrapperRef = useRef(null);
    ClickOutside(dropdownwrapperRef, setDropdownClick);

    useEffect(() => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getResponse.GetBrandList('/api/brand/projecttypes', accesstoken, (data) => {
                    if (data.status == 200) {
                        const templateArray = [];
                        data.data.data.map((template) => {
                            const templateObject = {id: 0, name: ''}
                            templateObject.id = template["idProjectType"];
                            templateObject.name = template["projectTypeName"];
                            templateArray.push(templateObject);
                        })
                        setTemplateList(templateArray);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [])

    const handleTemplate = (template) => {
        setDropdownClick(!isDropdownClicked);
        setTaskTemplateDetails({
            ...taskTemplateDetails,
            projectTypeId: template.id,
            projectTypeName: template.name
        })
    }

    const handleDropdown = () => {
        setDropdownClick(!isDropdownClicked);
    }

    const handleAddTask = () => {
        getTaskTemplateDetails(taskTemplateDetails);
    }

    return (
        <>
            <Modal
                show={taskTemplateShow}
                onHide={handleTaskTemplateClose} className='add-task-template-popup'
                centered>
                <Modal.Body className='add-task-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleTaskTemplateClose}/>
                    </div>
                    <div className='add-task-popup-header'>Add Task Template</div>
                    <div className='add-task-popup-body'>
                        <label className='required'>Project Type</label>
                        <div className='dropdown dropdown-order-container' ref={dropdownwrapperRef}>
                            <div className='dropdown-name-img dropdown-order' onClick={handleDropdown}>
                                <div className='dropdown-name'>{taskTemplateDetails.projectTypeName}</div>
                                <div><img className='arrow' src={isDropdownClicked ? upArrow : downArrow} alt=""></img></div>
                            </div>
                            {isDropdownClicked &&
                                <div className='dropdown-list'>
                                    {
                                        templateList.length > 0 && templateList.map((item, index) => {
                                            return (
                                                <div className='dropdown-content-inner order-dropdown-inner' key={index} 
                                                onClick={() => handleTemplate(item)}>{item.name}</div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button className='enable' onClick={handleAddTask}>Add</button>
                    </div>            
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddTaskTemplate;